export const CHARACTER_LIST_WRAPPED_TYPES = [
  'lh__speech-bquote',
  'lh__characters-list',
  'lh__characters-list-amp',
  'lh__speech-bquote-amp',
];
